import { useState, Fragment } from "react";

import { IconButton, CircularProgress } from "@mui/material";

import FleetWebApi from "../Api/FleetWebApi";

import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import ErrorIcon from "@mui/icons-material/Error";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import BlockIcon from '@mui/icons-material/Block';
import { useAuthDataContext, UserRoles } from '../AuthDataProvider';


type IDeleteUserPros = {
    userId: string;
};

function DeleteUser(props: IDeleteUserPros) {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };

    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };


    const handleComplete = () => {
        if (isSuccess) {
            setIsDialogOpen(false)
        } else {
            setIsLoading(true);
            FleetWebApi.deleteUser(
                props.userId
            ).then(
                result => {
                    if (result.result === true) {
                        setIsLoading(false);
                        setIsSuccess(true);
                    } else {
                        setSnackbarOpen(true);
                        setIsLoading(false);
                        setError("An unknown error occured");
                    }
                }
            ).catch(error => {
                setSnackbarOpen(true);
                setIsLoading(false);
                setError(error.message);
            })
        }
    };

    const { user } = useAuthDataContext();
    if (user?.roles.includes(UserRoles.admin)) {


        return (

            <Fragment>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                >
                    <SnackbarContent
                        className="errorSnackbar"
                        message={
                            <span id="message-id" className="snackbarMessage">
                                <ErrorIcon className="snackbarIcon" />
                                {error}
                            </span>
                        }
                        action={[
                            <IconButton
                                key="close"
                                aria-label="close"
                                color="inherit"
                                onClick={handleSnackbarClose}
                            >
                                <BlockIcon />
                            </IconButton>
                        ]}
                    />
                </Snackbar>

                {isLoading ? (
                    <CircularProgress size={24} />
                ) : (
                    <IconButton
                        key="close"
                        aria-label="close"
                        color="inherit"
                        onClick={handleDialogOpen}
                    >
                        <BlockIcon />
                    </IconButton>
                )}

                <Dialog
                    open={isDialogOpen}
                    onClose={handleDialogClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">
                        Delete User
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>Are you sure you want to delete this User?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleDialogClose}
                            color="primary"
                            variant="contained"
                        >
                            Cancel
                        </Button>
                        <div className="buttonWrapper">
                            <Button
                                onClick={handleComplete}
                                color="primary"
                                variant="contained"
                                disabled={isLoading}
                                className={isSuccess ? "buttonSuccess" : ""}
                            >
                                {isSuccess ? "Close" : "Delete"}
                            </Button>
                            {isLoading && (
                                <CircularProgress size={24} className="buttonProgress" />
                            )}
                        </div>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    } else {
        return (null)
    }
}

export default DeleteUser;
